module.exports = (parcelRequire.load("cipen")).then(() => parcelRequire('l0e0U'));